/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface CreatePromoCode200ResponseData
 */
export interface CreatePromoCode200ResponseData {
  /**
   *
   * @type {string}
   * @memberof CreatePromoCode200ResponseData
   */
  code: string
  /**
   *
   * @type {Date}
   * @memberof CreatePromoCode200ResponseData
   */
  startAt: Date
  /**
   *
   * @type {Date}
   * @memberof CreatePromoCode200ResponseData
   */
  expireAt: Date
}

/**
 * Check if a given object implements the CreatePromoCode200ResponseData interface.
 */
export function instanceOfCreatePromoCode200ResponseData(
  value: object
): value is CreatePromoCode200ResponseData {
  if (!('code' in value) || value['code'] === undefined) return false
  if (!('startAt' in value) || value['startAt'] === undefined) return false
  if (!('expireAt' in value) || value['expireAt'] === undefined) return false
  return true
}

export function CreatePromoCode200ResponseDataFromJSON(
  json: any
): CreatePromoCode200ResponseData {
  return CreatePromoCode200ResponseDataFromJSONTyped(json, false)
}

export function CreatePromoCode200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreatePromoCode200ResponseData {
  if (json == null) {
    return json
  }
  return {
    code: json['code'],
    startAt: new Date(json['startAt']),
    expireAt: new Date(json['expireAt']),
  }
}

export function CreatePromoCode200ResponseDataToJSON(
  value?: CreatePromoCode200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    code: value['code'],
    startAt: value['startAt'].toISOString(),
    expireAt: value['expireAt'].toISOString(),
  }
}
